module.exports = __webpack_public_path__ + "img/jiankong.df8aa406.png";